module.exports = __webpack_public_path__ + "static/media/Slice25@2x.d94b7c8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice25@2x.png
// module id = 1453
// module chunks = 0